import { Button, CircularProgress, useTheme } from '@mui/material';
import { ReactNode } from 'react';

export type IndicacaoButtonVariant = 'primary' | 'outlined' | 'ghost' | 'danger' | 'success';

interface IndicacaoButtonProps {
	label: string;
	icon?: ReactNode;
	onClick?: () => void;
	disabled?: boolean;
	loading?: boolean;
	fullWidth?: boolean;
	size?: 'small' | 'medium';
	variant?: IndicacaoButtonVariant;
}

export function IndicacaoButton({
	label,
	icon,
	onClick,
	disabled,
	loading,
	fullWidth,
	size = 'medium',
	variant = 'primary',
}: IndicacaoButtonProps) {
	const theme = useTheme();
	const primary = theme.palette.primary.main;
	const styles = {
		primary: {
			bgcolor: primary,
			color: '#fff',
			border: '1px solid transparent',
			'&:hover': { bgcolor: theme.palette.primary.dark || '#e65c00' },
		},
		outlined: {
			bgcolor: '#fff',
			color: 'text.primary',
			border: '1px solid #e2e8f0',
			'&:hover': { bgcolor: '#f8fafc', borderColor: '#cbd5e1' },
		},
		ghost: {
			bgcolor: 'transparent',
			color: 'text.primary',
			border: '1px solid transparent',
			'&:hover': { bgcolor: '#f8fafc' },
		},
		danger: {
			bgcolor: '#fff',
			color: 'rgb(220, 38, 38)',
			border: '1px solid rgba(220, 38, 38, 0.28)',
			'&:hover': { bgcolor: 'rgba(220, 38, 38, 0.06)' },
		},
		success: {
			bgcolor: 'rgb(5, 150, 105)',
			color: '#fff',
			border: '1px solid transparent',
			'&:hover': { bgcolor: 'rgb(4, 120, 87)' },
		},
	};

	return (
		<Button
			onClick={onClick}
			disabled={disabled || loading}
			startIcon={loading ? <CircularProgress size={14} color="inherit" /> : icon}
			size={size}
			fullWidth={fullWidth}
			sx={{
				textTransform: 'none',
				whiteSpace: 'nowrap',
				boxShadow: 'none',
				fontWeight: 700,
				borderRadius: 2,
				px: size === 'small' ? 1.5 : 2,
				py: size === 'small' ? 0.75 : 1,
				minWidth: size === 'small' ? 0 : 120,
				width: { xs: '100%', sm: fullWidth ? '100%' : 'auto' },
				...styles[variant],
			}}
		>
			{label}
		</Button>
	);
}
